
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { useAppStore } from "../store/useAppStore";
import { Check, Shirt, Smartphone, Coffee, ShoppingBag, StickyNote, Image } from "lucide-react";

const categoryIcons: Record<string, React.ReactNode> = {
  "t-shirt": <Shirt className="h-5 w-5" />,
  "phone-case": <Smartphone className="h-5 w-5" />,
  "mug": <Coffee className="h-5 w-5" />,
  "tote-bag": <ShoppingBag className="h-5 w-5" />,
  "sticker": <StickyNote className="h-5 w-5" />,
};

export function TemplateSelector() {
  const { selectedTemplate, setSelectedTemplate } = useAppStore();

  const { data: templates, isLoading } = useQuery({
    queryKey: ["templates"],
    queryFn: api.listTemplates,
  });

  if (isLoading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin h-6 w-6 border-2 border-primary-500 border-t-transparent rounded-full mx-auto" />
      </div>
    );
  }

  if (!templates?.length) {
    return (
      <div className="text-center py-8 text-gray-500">
        暫無產品模板
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="font-semibold">選擇產品</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {templates.map((template) => (
          <button
            key={template.id}
            onClick={() => setSelectedTemplate(template)}
            className={`
              relative p-4 rounded-xl border-2 text-left transition-all
              ${selectedTemplate?.id === template.id
                ? "border-primary-500 bg-primary-50"
                : "border-gray-200 bg-white hover:border-gray-300"
              }
            `}
          >
            {selectedTemplate?.id === template.id && (
              <div className="absolute top-2 right-2 text-primary-500">
                <Check className="h-4 w-4" />
              </div>
            )}

            <div className="flex items-center gap-2 mb-2 text-gray-600">
              {categoryIcons[template.category] || <Image className="h-5 w-5" />}
              <span className="text-xs uppercase tracking-wide">{template.category}</span>
            </div>

            <div className="font-medium text-sm">{template.name}</div>

            {template.basePrice && (
              <div className="text-xs text-gray-500 mt-1">
                基礎價: ${template.basePrice}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
